let cookiesHash;

$( window ).on( 'load', function() {
    cookiesHash = $( '#cookie-notice' ).data( 'hash' );
    CheckCookies();
} );

$( '#cookie-notice #cn-accept-cookie' ).click( function() {
    CloseCookiesWindow();
} );

function CheckCookies() {
    if ( $.cookie( 'td_cookies_accepted' ) != cookiesHash ) {
        $( '#cookie-notice' ).css( 'display', 'block' );
    } else {
        CloseCookiesWindow();
    }
}

function CloseCookiesWindow() {
    $.cookie( 'td_cookies_accepted', cookiesHash, {
        expires: 365
    } );
    $( '#cookie-notice' ).remove();
}
